export default __webpack_public_path__ + "static/media/img-join-merchant-new.5cf1b560.png";